<template>
  <fieldset class="flex flex-col gap-4">
    <slot></slot>
  </fieldset>
</template>

<script setup></script>

<style lang="scss" scoped></style>
